export default __webpack_public_path__ + "static/media/hht2_ep1_speaking_01.f2a5e665.png";